import React from "react";

const BandAEmergency = () => {

  return (
    <div className="w-full min-h-screen bg-white font-sans">
      {/* Hero Section */}
      <div className="relative bg-[#14532d] text-white py-12 md:py-16 overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.4'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
            backgroundSize: '60px 60px'
          }}> 
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 relative z-10">
          <div className="flex flex-col lg:flex-row items-center justify-between">
            <div className="lg:w-2/3">
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold leading-tight uppercase tracking-tight">
              Band ‘A’ Emergency <span className="text-yellow-400">Contacts</span>
              </h1>
              <div className="w-20 h-1.5 bg-yellow-400 rounded-full mb-6"></div>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6 md:py-8">
        <div className="bg-black text-white p-4 sm:p-6 md:p-8 mb-6 shadow-xl rounded-xl md:rounded-2xl border-l-[6px] md:border-l-[8px] border-green-700 relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-700/10 rounded-full -mr-32 -mt-32 group-hover:scale-110 transition-transform duration-700"></div>
          <p className="text-base sm:text-lg md:text-xl font-black uppercase tracking-tight relative z-10 leading-tight">
            Dedicated emergency response lines for immediate technical assistance and fault reporting.
          </p>
        </div>

        <div className="relative rounded-xl overflow-hidden shadow-xl border-4 border-white ring-1 ring-gray-100 transform hover:scale-[1.01] transition-transform duration-500 mb-6">
           <object 
              width="100%" 
              data="/file/BEDC RAPID RESPONSE NUMBERS 2025.pdf" 
              type="application/pdf" 
              className="w-full h-[350px] md:h-[500px]"
            >
              <div className="p-10 text-center bg-gray-50">
                <p className="text-sm sm:text-base font-bold">PDF viewing not supported by your browser.</p>
              </div>
            </object>
        </div>

        <div className="p-5 sm:p-6 bg-gray-50 rounded-xl md:rounded-2xl text-center border border-gray-100 shadow-sm">
          <h3 className="text-base sm:text-lg md:text-xl font-black text-black uppercase mb-3">Need Immediate Help?</h3>
          <p className="max-w-3xl mx-auto text-gray-600 font-medium leading-relaxed mb-4 text-xs sm:text-sm md:text-base">
            Our rapid response team is on standby 24/7 to address any power supply issues for Band A customers. Use the contact information provided in the flyer above for your specific region.
          </p>
          <a href="/contact" className="inline-block bg-green-700 text-white px-6 py-3 rounded-xl font-black uppercase tracking-widest text-[10px] sm:text-xs hover:bg-yellow-400 hover:text-black transition-all shadow-lg">
            General Enquiries →
          </a>
        </div>
      </div>
    </div>
  );
};

export default BandAEmergency;